import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import Form from "theme/components/atoms/Form/Form";
import Icon from "theme/components/atoms/Icon";
import Select from "theme/components/atoms/Form/Input/Select";
import IsDesktop from "theme/utils/isDesktop";
import EnhanceLimit from "./EnhanceLimit";

const Limit = (props) => (
  <IsDesktop>
    {(isDesktop) => (
      <Form onChange={props.limitAction} className="limit-form">
        <div className="category-limit">
          <Select
            disableValidation
            light
            icon={<Icon icon="chevron-down" size="tiny" title="select store" />}
            iconOpen={
              <Icon icon="chevron-up" size="tiny" title="select store" />
            }
            name="limit"
            id="limit"
            value={props.currentValue}
            placeholder={
              isDesktop ? (
                <FormattedMessage
                  id="components.molecules.limit.desktopLabel"
                  defaultMessage="Result by pages"
                />
              ) : (
                <FormattedMessage
                  id="components.molecules.limit.mobileLabel"
                  defaultMessage="Result by pages"
                />
              )
            }
            options={props.options}
          />
        </div>
      </Form>
    )}
  </IsDesktop>
);

Limit.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  toggleLimit: PropTypes.func,
  limitAction: PropTypes.func,
  limitIsVisible: PropTypes.bool,
};

export default EnhanceLimit()(Limit);
